import { render, staticRenderFns } from "./HealthAnalysis.vue?vue&type=template&id=23cde11e&scoped=true&"
import script from "./HealthAnalysis.vue?vue&type=script&lang=js&"
export * from "./HealthAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./HealthAnalysis.vue?vue&type=style&index=0&id=23cde11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cde11e",
  null
  
)

export default component.exports